export const WEEKDAY_KEYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// react-day-picker (and JS Date#getDay) index weekdays Sun=0 ... Sat=6.
const KEY_TO_RDP_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

/** Normalizes a possibly-legacy time entry (plain string) into { time, days }. */
export function normalizeTimeSlot(entry) {
  if (typeof entry === "string") {
    return { time: entry, days: [...WEEKDAY_KEYS] };
  }
  return {
    time: entry.time,
    days: entry.days?.length ? entry.days : [...WEEKDAY_KEYS],
  };
}

/** Returns the normalized time slots for a ferry, for the given direction. */
export function getTimeSlots(ferry, direction = "departure") {
  const raw = direction === "return" ? ferry?.returnTimes : ferry?.departureTimes;
  return (raw || []).map(normalizeTimeSlot);
}

/** Returns only the time slots that run on the weekday of the given JS Date. */
export function slotsForDate(ferry, date, direction = "departure") {
  if (!date) return getTimeSlots(ferry, direction);
  const rdpIndex = date.getDay(); // 0=Sun..6=Sat
  return getTimeSlots(ferry, direction).filter((slot) =>
    slot.days.some((key) => KEY_TO_RDP_INDEX[key] === rdpIndex),
  );
}

/** True if this ferry runs at least one timing on the weekday of `date`. */
export function isDateAvailableForFerry(ferry, date, direction = "departure") {
  return slotsForDate(ferry, date, direction).length > 0;
}

/**
 * react-day-picker v9 `disabled` matcher: disables every weekday that has
 * no departure (or return) timing at all for this ferry.
 *
 * Usage: <DayPicker disabled={getDisabledWeekdayMatcher(selectedFerry, "departure")} />
 */
export function getDisabledWeekdayMatcher(ferry, direction = "departure") {
  const allowedRdpIndexes = new Set();
  getTimeSlots(ferry, direction).forEach((slot) => {
    slot.days.forEach((key) => allowedRdpIndexes.add(KEY_TO_RDP_INDEX[key]));
  });
  const disabledIndexes = [0, 1, 2, 3, 4, 5, 6].filter(
    (i) => !allowedRdpIndexes.has(i),
  );
  return { dayOfWeek: disabledIndexes };
}